import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLegend,
  FieldSeparator,
  FieldSet,
} from "@/client/components/shad/field";
import { withForm } from "../../form-context";
import { signInFormOptions } from "../shared";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@/client/components/shad/input-otp";
import { REGEXP_ONLY_DIGITS } from "input-otp";

export const PinBlock = withForm({
  ...signInFormOptions,

  render: function Render({ form }) {
    return (
      <FieldSet>
        <FieldLegend variant="title">Enter PIN</FieldLegend>
        <FieldDescription>Enter your PIN on keypad for access</FieldDescription>

        <FieldGroup className="flex justify-center items-center">
          <form.AppField name="pin">
            {(field) => (
              <Field>
                <div className="flex flex-col items-center justify-center">
                  <InputOTP
                    autoFocus
                    id="pin-digits-only"
                    name={field.name}
                    value={field.state.value}
                    onChange={field.handleChange}
                    maxLength={6}
                    pattern={REGEXP_ONLY_DIGITS}
                    onComplete={() => form.handleSubmit()}
                  >
                    <InputOTPGroup className="*:data-[slot=input-otp-slot]:h-12 *:data-[slot=input-otp-slot]:w-14 *:data-[slot=input-otp-slot]:text-base">
                      <InputOTPSlot index={0} />
                      <InputOTPSlot index={1} />
                      <InputOTPSlot index={2} />
                      <InputOTPSlot index={3} />
                      <InputOTPSlot index={4} />
                      <InputOTPSlot index={5} />
                    </InputOTPGroup>
                  </InputOTP>
                </div>

                <FieldSeparator className="my-2" />

                <div className="grid grid-cols-3 gap-1 content-center font-bold">
                  <KeyButton
                    label="1"
                    onClick={() => field.setValue(field.state.value + "1")}
                  />
                  <KeyButton
                    label="2"
                    onClick={() => field.setValue(field.state.value + "2")}
                  />
                  <KeyButton
                    label="3"
                    onClick={() => field.setValue(field.state.value + "3")}
                  />
                  <KeyButton
                    label="4"
                    onClick={() => field.setValue(field.state.value + "4")}
                  />
                  <KeyButton
                    label="5"
                    onClick={() => field.setValue(field.state.value + "5")}
                  />
                  <KeyButton
                    label="6"
                    onClick={() => field.setValue(field.state.value + "6")}
                  />
                  <KeyButton
                    label="7"
                    onClick={() => field.setValue(field.state.value + "7")}
                  />
                  <KeyButton
                    label="8"
                    onClick={() => field.setValue(field.state.value + "8")}
                  />
                  <KeyButton
                    label="9"
                    onClick={() => field.setValue(field.state.value + "9")}
                  />
                  <KeyButton label="Clear" onClick={() => field.setValue("")} />
                  <KeyButton
                    label="0"
                    onClick={() => field.setValue(field.state.value + "0")}
                  />

                  <KeyButton
                    label="Back"
                    onClick={() =>
                      field.setValue(field.state.value.slice(0, -1))
                    }
                  />
                </div>
              </Field>
            )}
          </form.AppField>
        </FieldGroup>
      </FieldSet>
    );
  },
});

const KeyButton = ({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) => {
  return (
    <div
      role="button"
      onClick={onClick}
      className="bg-sidebar-accent/50
          py-6.5
          rounded-xs
          cursor-pointer
          select-none
          transition-colors
          duration-75
          active:text-sidebar-accent-foreground/50
          active:bg-sidebar-accent/20
          nth-[3]:rounded-tr-lg
          nth-[1]:rounded-tl-lg
          nth-[10]:rounded-bl-lg
          nth-[12]:rounded-br-lg"
    >
      <span>{label}</span>
    </div>
  );
};
